// extracted by mini-css-extract-plugin
module.exports = {"container":"Tag_container__1mrhh","text":"Tag_text__dy0a6","button":"Tag_button__2wE15","icon":"Tag_icon__24imX"};